import React, { useEffect, useRef, useState } from 'react';
import { ArrowRightIcon, CheckCircle2Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const SALES_PAGE_URL = 'https://amee.stresslessdogs.nl/stressless-communication-127';
function Stars() {
  return <div className="flex gap-0.5 text-[#c9653d]" aria-label="5 van de 5 sterren" data-id="element-4414" data-mp="3jvm4dlct37np">
      {Array.from({
      length: 5
    }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-4415" data-mp="2s225akzabdll" />)}
    </div>;
}
function InlineCourseCta() {
  return <aside className="my-12 rounded-2xl border border-[#e7bda9] bg-[#fff7f2] p-6 text-center shadow-sm" data-id="element-4416" data-mp="2n4tnwmlyndle">
      <h3 className="font-serif text-2xl font-bold text-[#39251d]" data-id="element-4417" data-mp="314bgld2dnb01">
        Benieuwd wat jouw hond je vertelt?
      </h3>
      <p className="mt-3 text-lg leading-relaxed text-[#5c453b]" data-id="element-4418" data-mp="2w69wcot7t5mz">
        Nu met 48% korting op de cursus Liefdevol Communiceren Met Je Hond.
      </p>
      <a href={SALES_PAGE_URL} className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#c9653d] px-5 py-3.5 font-bold text-white shadow-[0_4px_12px_rgba(135,70,41,0.22)] transition-colors hover:bg-[#ae5230] focus:outline-none focus:ring-4 focus:ring-[#f1c7b5]" data-id="element-4419" data-mp="bcoe7tm8q88l">
        Bekijk de cursus
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-4420" data-mp="3k3vripuq12kz" />
      </a>
    </aside>;
}
function VijfRedenenCommunicerenAdv6KortLcContent() {
  const inlineCtaRef = useRef<HTMLDivElement>(null);
  const [showStickyCta, setShowStickyCta] = useState(false);
  useEffect(() => {
    const updateStickyCta = () => {
      const cta = inlineCtaRef.current;
      if (!cta) return;
      setShowStickyCta(cta.getBoundingClientRect().bottom < 0);
    };
    updateStickyCta();
    window.addEventListener('scroll', updateStickyCta, {
      passive: true
    });
    window.addEventListener('resize', updateStickyCta);
    return () => {
      window.removeEventListener('scroll', updateStickyCta);
      window.removeEventListener('resize', updateStickyCta);
    };
  }, []);
  return <div className="min-h-screen bg-white pb-24 text-[#262321] md:pb-0" data-id="element-4421" data-mp="25nvx3k9p39sn">
      <div className="sticky top-0 z-50 bg-[#c9653d] px-4 py-2 text-center text-xs font-medium leading-relaxed text-white shadow-sm md:text-sm" data-id="element-4422" data-mp="21o4w6nqgfdae">
        Nu met 48% korting op de cursus Liefdevol Communiceren Met Je Hond
      </div>

      <header className="border-b border-stone-200" data-id="element-4423" data-mp="2aggpchcydeu2">
        <div className="mx-auto flex max-w-[680px] items-center justify-between px-5 py-4" data-id="element-4424" data-mp="1mq2rubblmns3">
          <span className="font-serif text-base font-bold tracking-tight text-[#342d29]" data-id="element-4425" data-mp="1ip0rts9uy7p2">
            Stressless Dogs
          </span>
          <span className="text-xs text-stone-400" data-id="element-4426" data-mp="1wpjv6m3dopkw">Advertorial</span>
        </div>
      </header>

      <main data-id="element-4427" data-mp="1roe2go9px2bd">
        <article className="mx-auto max-w-[680px] px-5 pb-14 pt-10 md:pt-14" data-id="element-4428" data-mp="1rnukj7k2idxc">
          <header className="border-b border-stone-200 pb-8" data-id="element-4429" data-mp="382mehowv3t8r">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.14em] text-[#b45734]" data-id="element-4430" data-mp="334kun1rm3pw8">
              Honden &amp; Gedrag
            </p>
            <h1 className="font-serif text-[2.1rem] font-bold leading-[1.08] tracking-[-0.025em] text-[#201d1b] md:text-5xl" data-id="element-4431" data-mp="ovs6xmk1kmel">
              Waarom ruim 100.000 Nederlandse hondenbaasjes stoppen met corrigeren
              (en ervoor kiezen om hondentaal te leren)
            </h1>
            <p className="mt-5 text-xl font-medium leading-relaxed text-stone-600 md:text-2xl" data-id="element-4432" data-mp="kugb2zakr4xy">
              5 redenen waarom liefdevolle baasjes overstappen
            </p>
            <div className="mt-7 flex items-center gap-3 text-sm text-stone-500" data-id="element-4433" data-mp="1cme8qw3gdag5">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#e8c9b9] font-serif font-bold text-[#8a4b32]" aria-hidden="true" data-id="element-4434" data-mp="1co8mnqgb42aq">
                S
              </div>
              <div data-id="element-4435" data-mp="1rjesacbhpz3j">
                <p className="font-medium text-stone-700" data-id="element-4436" data-mp="1riwpewubommn">Door de redactie van Stressless Dogs</p>
                <p data-id="element-4437" data-mp="1wb6n4z1oiqzh">12 juni 2026 · Leestijd: 3 minuten</p>
              </div>
            </div>
          </header>

          <figure className="my-8 overflow-hidden rounded-2xl bg-stone-100" data-id="element-4438" data-mp="7q58rp80w23l">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/1aa86ec3-846d-4f2d-a96b-6be412601c19.jpg" alt="Baasje communiceert met hond" className="h-auto w-full" data-id="element-4439" data-mp="2ofv01tf1abt" />
          </figure>

          <div className="space-y-6 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4440" data-mp="qf23tvb8uymv">
            <p data-id="element-4441" data-mp="qgwd2cd5l2b4">
              Je hond is superlief. Echt waar. En toch blaft hij de hele boel bij
              elkaar, trekt hij aan de lijn of valt hij 'uit het niets' uit.
            </p>
            <p data-id="element-4442" data-mp="hkneezx027q1">
              Je hebt vast al van alles geprobeerd. Strenger zijn. 'Nee!' roepen.
              Corrigeren, zoals iedereen zegt dat je moet doen.
            </p>
            <p data-id="element-4443" data-mp="1a4lx1xeuly9s">En toch wordt het niet beter. Sterker nog: vaak wordt het erger.</p>
            <p data-id="element-4444" data-mp="15baysko3qpth">
              Daar is een reden voor. En die reden verklaart waarom ruim 100.000
              Nederlandse hondenbaasjes het inmiddels anders doen. Zij leren geen
              commando's, maar hondentaal.
            </p>
          </div>

          <aside className="my-10 rounded-2xl border border-[#ead9cf] bg-[#fffbf8] p-6 shadow-sm" data-id="element-4445" data-mp="1mloeyqc4r32a">
            <div className="flex items-center gap-3" data-id="element-4446" data-mp="1qn9z8wqzujmi">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee van Stressless Dogs" className="h-12 w-12 rounded-full object-cover" data-id="element-4447" data-mp="1qoteql4tsqn8" />
              <p className="text-sm font-bold text-[#8a4b32]" data-id="element-4448" data-mp="25dh6egbjwg7w">Amee · Stressless Dogs</p>
            </div>
            <blockquote className="mt-5 font-serif text-xl leading-relaxed text-[#3c2c25] md:text-2xl" data-id="element-4449" data-mp="2a9xwvh6836o5">
              'Een hond doet nooit iets uit het niets. Wij mensen hebben alleen
              nooit leren kijken. Tegen de tijd dat een hond blaft of uitvalt, is
              hij al minutenlang aan het communiceren. Het probleem is niet dat
              honden onduidelijk zijn. Het probleem is dat niemand ons ooit hun
              taal heeft geleerd.'
            </blockquote>
          </aside>

          <p className="text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4450" data-mp="t128h8141y85">
            Dat is precies wat steeds meer baasjes nu wél doen. Dit zijn de vijf
            redenen die zij zelf noemen:
          </p>

          <section className="mt-14" data-id="element-4451" data-mp="12vu80he96v5k">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4452" data-mp="xyu7sn434mmd">
              1. Je hond praat de hele dag tegen je. Jij hebt het alleen nooit leren verstaan.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4453" data-mp="170k15yhj1vms">
              Zoals een cursist het zei: 'Ons hondje heeft voor mij nog een Chinese
              handleiding.' Honden communiceren continu met hun lichaam. Wie die
              taal leert lezen, ziet spanning aankomen voordat het misgaat. Geen
              verrassingen meer 'uit het niets'.
            </p>
          </section>

          <section className="mt-14" data-id="element-4454" data-mp="1t75whhjr622r">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4455" data-mp="1fg9c2dzzcr6s">
              2. Omdat 'af!' roepen nog nooit een hond stiller heeft gemaakt.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4456" data-mp="15hk011urm0yg">
              Blaffen, trekken en uitvallen zijn geen ongehoorzaamheid. Het zijn
              boodschappen. Corrigeren onderdrukt hooguit het signaal, maar de
              emotie eronder blijft. Daarom komt het gedrag altijd terug, of komt
              er iets anders voor in de plaats. Wie de boodschap begrijpt, kan
              eindelijk bij de oorzaak beginnen.
            </p>
            <div ref={inlineCtaRef} data-id="element-4457" data-mp="2qtljeyuy7rxp">
              <InlineCourseCta data-id="element-4458" data-mp="2uxb59gk8nvf1" />
            </div>
          </section>

          <section className="mt-14" data-id="element-4459" data-mp="1inobepyoujxn">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4460" data-mp="1immq7snykh27">
              3. Wat eruitziet als stoer gedrag, is bijna altijd angst.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4461" data-mp="18wjwtrcxd13c">
              Duizenden baasjes ontdekten dat hun 'agressieve' hond eigenlijk een
              onzekere hond in een stoer lichaam is. Dat verandert alles. Want een
              bange hond straf je niet, die help je. En nee, je hond troosten
              versterkt de angst niet. Dat is een hardnekkige mythe.
            </p>
            <blockquote className="my-9 border-l-4 border-[#c9653d] pl-5 font-serif text-2xl italic leading-snug text-[#624334] md:text-3xl" data-id="element-4462" data-mp="pz90ofmlans4">
              “Wat eruitziet als agressie is bijna altijd angst. Een onzekere hond
              in een stoer lichaam.”
              <footer className="mt-3 font-sans text-sm font-bold not-italic text-[#9a5236]" data-id="element-4463" data-mp="2fdp0kq2yz2fh">
                Amee, Stressless Dogs
              </footer>
            </blockquote>
          </section>

          <section className="mt-14" data-id="element-4464" data-mp="2rvr9t8xuatm8">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4465" data-mp="2ruq13b4aqj7o">
              4. Rust aan beide kanten van de lijn.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4466" data-mp="31lufo9q2821z">
              'Wandelen is vooral stress in plaats van ontspanning,' schreef een
              baasje. Herkenbaar? Jouw spanning loopt via de lijn rechtstreeks
              naar je hond, en andersom. Baasjes die hun hond leren lezen, merken
              dat ze zelf ook ontspannen. De wandeling wordt weer waar je hem voor
              nam: samen genieten.
            </p>
            <figure className="my-8 overflow-hidden rounded-2xl bg-stone-100" data-id="element-4467" data-mp="3pcgav0eytruk">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/9240b968-cbf1-4f2f-ba2c-d8c18510d8e0.jpg" alt="Ontspannen wandelen met je hond" className="h-auto w-full" data-id="element-4468" data-mp="3ub1aaxme87hy" />
            </figure>
          </section>

          <section className="mt-14" data-id="element-4469" data-mp="10my4wuwvneq6">
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-[-0.015em] text-[#25211f] md:text-4xl" data-id="element-4470" data-mp="15fr9niscin29">
              5. Voor de band die je altijd al wilde.
            </h2>
            <p className="mt-5 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4471" data-mp="cs3q872ta2h7">
              Of je nu een puppy hebt, een adoptiehond met een rugzakje, of een
              trouwe metgezel van acht jaar: begrijpen schept vertrouwen. En als
              je bij een vorige hond dingen anders had willen doen: dat was geen
              onwil, dat was liefde zonder de juiste kennis. Die kennis bestaat nu
              wel.
            </p>
          </section>
        </article>

        <section className="mx-auto max-w-[680px] px-5 py-14" data-id="element-4472" data-mp="226052ry8vcmb">
          <h2 className="font-serif text-3xl font-bold leading-tight text-[#25211f] md:text-4xl" data-id="element-4473" data-mp="224fdnb7889so">
            Waar begin je?
          </h2>
          <div className="mt-5 space-y-6 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4474" data-mp="27bdmijq91lr4">
            <p data-id="element-4475" data-mp="22k5gzys1ikj8">
              Hondentaal leren is de basis. Niet de totaaloplossing voor elk
              probleem, wel de eerste stap waar elke gedragsverandering mee begint.
              Zonder begrip is elke training gokken.
            </p>
            <p data-id="element-4476" data-mp="1tlaaell338fe">
              Daarom ontwikkelde Amee met Stressless Dogs de cursus Liefdevol
              Communiceren. Een online cursus die je in je eigen tempo volgt,
              waarin je stap voor stap leert:
            </p>
          </div>

          <ul className="mt-7 space-y-5 text-[18px] leading-[1.6] text-[#34302d] md:text-[19px]" data-id="element-4477" data-mp="1fk7ms4efxq2d">
            <li className="flex gap-3" data-id="element-4478" data-mp="3dzaix0kckf1s">
              <CheckCircle2Icon className="mt-1 h-5 w-5 flex-none text-[#c9653d]" aria-hidden="true" data-id="element-4479" data-mp="3dy9az4ymo8oa" />
              <span data-id="element-4480" data-mp="39ygwkbmjz8b0">De lichaamstaal van je hond lezen: oren, staart, houding, blik, en de kleine stresssignalen die bijna iedereen mist</span>
            </li>
            <li className="flex gap-3" data-id="element-4481" data-mp="1c1qozb2a48cr">
              <CheckCircle2Icon className="mt-1 h-5 w-5 flex-none text-[#c9653d]" aria-hidden="true" data-id="element-4482" data-mp="1c3l7kiq2vodo" />
              <span data-id="element-4483" data-mp="yc6qihfqdx99">Herkennen welke emotie er onder gedrag zit (angst, frustratie, opwinding of onzekerheid), want dat bepaalt wat je hond van je nodig heeft</span>
            </li>
            <li className="flex gap-3" data-id="element-4484" data-mp="1q2uoxlq0soj8">
              <CheckCircle2Icon className="mt-1 h-5 w-5 flex-none text-[#c9653d]" aria-hidden="true" data-id="element-4485" data-mp="1pzp1eax1hupm" />
              <span data-id="element-4486" data-mp="1uyie414i5hoq">Spanning zien aankomen vóórdat het misgaat, zodat 'uit het niets' verleden tijd is</span>
            </li>
            <li className="flex gap-3" data-id="element-4487" data-mp="1lzy37m56ocb2">
              <CheckCircle2Icon className="mt-1 h-5 w-5 flex-none text-[#c9653d]" aria-hidden="true" data-id="element-4488" data-mp="1lymwpekcsqg9" />
              <span data-id="element-4489" data-mp="5kd9inrul7r0">Zelf duidelijk communiceren op een manier die je hond wél begrijpt, met je lichaam in plaats van steeds meer woorden</span>
            </li>
            <li className="flex gap-3" data-id="element-4490" data-mp="23he2688sd9t">
              <CheckCircle2Icon className="mt-1 h-5 w-5 flex-none text-[#c9653d]" aria-hidden="true" data-id="element-4491" data-mp="22fs36pou6db" />
              <span data-id="element-4492" data-mp="3u7jnixbxxyrf">En dat alles zonder corrigeren, zonder straffen en zonder achterhaalde verhalen over 'de baas zijn'</span>
            </li>
          </ul>

          <p className="mt-7 text-[19px] leading-[1.7] text-[#34302d] md:text-xl" data-id="element-4493" data-mp="72lkip3s7wwg">
            Geen theorieboek, maar videolessen met echte honden en echte situaties,
            die je direct op je eigen wandeling toepast.
          </p>

          <section id="salespagina" className="mt-10 rounded-3xl bg-[#f8e1d4] p-7 text-center shadow-[0_10px_25px_rgba(93,57,39,0.1)] md:p-10" aria-labelledby="course-heading" data-id="element-4494" data-mp="3aleuyt19k5me">
            <p className="text-xs font-bold tracking-[0.16em] text-[#a04b2d]" data-id="element-4495" data-mp="3kg6tq06l0yir">
              TIJDELIJKE ACTIE · 48% KORTING
            </p>
            <h2 id="course-heading" className="mt-3 font-serif text-3xl font-bold text-[#33231d] md:text-4xl" data-id="element-4496" data-mp="2ru47ymynsczs">
              Cursus Liefdevol Communiceren
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-[#604236]" data-id="element-4497" data-mp="2012334pn28nv">
              Nu met 48% korting op de cursus Liefdevol Communiceren Met Je Hond
            </p>
            <div className="mx-auto mt-6 flex max-w-lg items-start gap-3 rounded-2xl bg-white/65 p-4 text-left text-sm leading-relaxed text-[#5e463b]" data-id="element-4498" data-mp="241ce4vsafp9l">
              <ShieldCheckIcon className="mt-0.5 h-6 w-6 flex-none text-[#a65031]" aria-hidden="true" data-id="element-4499" data-mp="2dt8gwk5bk3k5" />
              <p data-id="element-4500" data-mp="2iqqreeyziqu9">
                <strong data-id="element-4501" data-mp="2iq8kmoep4u83">30 dagen niet-goed-geld-terug-garantie.</strong> Bevalt de
                cursus niet, dan krijg je zonder gedoe je geld terug. Je kunt het
                dus gewoon proberen.
              </p>
            </div>
            <a href={SALES_PAGE_URL} className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#c9653d] px-6 py-4 text-lg font-bold text-white shadow-[0_4px_12px_rgba(135,70,41,0.22)] transition-colors hover:bg-[#ae5230] focus:outline-none focus:ring-4 focus:ring-[#f1c7b5]" data-id="element-4502" data-mp="2rpvqpnideo7h">
              Ja, ik wil de taal van mijn hond leren
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-4503" data-mp="l24s6opeamek" />
            </a>
            <p className="mt-3 text-sm text-[#73564a]" data-id="element-4504" data-mp="g54p8mnudzro">Direct toegang · In je eigen tempo · 30 dagen garantie</p>
          </section>

          <section className="mt-12 -mx-5 bg-stone-100 px-5 py-10" aria-labelledby="testimonials-heading" data-id="element-4505" data-mp="18ta8f4z8zgpe">
            <div className="mx-auto max-w-[760px]" data-id="element-4506" data-mp="13txmcmg7adnv">
              <h2 id="testimonials-heading" className="mb-6 text-center font-serif text-2xl font-bold text-[#282321]" data-id="element-4507" data-mp="13v8neei9h7ba">
                Wat baasjes zeggen
              </h2>
              <div className="grid gap-4 md:grid-cols-3" data-id="element-4508" data-mp="usprkecw7uyj">
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4509" data-mp="3kj2zrjpas9om">
                  <Stars data-id="element-4510" data-mp="3kh01ydhwlc9c" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4511" data-mp="3fk9ntvpnsqqk">
                    “Eindelijk begrijp ik wat ze me al die tijd probeerde te vertellen.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4512" data-mp="3m0rzgn6378p0">Annemiek &amp; Luna</figcaption>
                </figure>
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4513" data-mp="37zpe6cmx22f5">
                  <Stars data-id="element-4514" data-mp="3c1awidi7z8wq" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4515" data-mp="3c0hl2z8bfv89">
                    “Onze wandelingen zijn nu ontspannen in plaats van stress.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4516" data-mp="332yvrinn2uqk">Peter &amp; Max</figcaption>
                </figure>
                <figure className="rounded-2xl bg-white p-5 shadow-sm" data-id="element-4517" data-mp="2oanaypfdskrp">
                  <Stars data-id="element-4518" data-mp="2tc4c8m1s298t" />
                  <blockquote className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-4519" data-mp="2t988gh390qcg">
                    “Ik zie nu signalen die ik vijf jaar lang heb gemist.”
                  </blockquote>
                  <figcaption className="mt-4 text-sm font-bold text-stone-900" data-id="element-4520" data-mp="2kcpklj9vjsmq">Sandra &amp; Boef</figcaption>
                </figure>
              </div>
            </div>
          </section>
        </section>
      </main>

      <footer className="border-t border-stone-200 px-5 py-9 text-center text-sm text-stone-500" data-id="element-4521" data-mp="29pj7khn3dyla">
        <p className="font-serif font-bold text-stone-700" data-id="element-4522" data-mp="25ofs3w8yi4kl">Stressless Dogs</p>
        <div className="mt-3 flex justify-center gap-4" data-id="element-4523" data-mp="25qk4z3ou2dx0">
          <a href={SALES_PAGE_URL} className="underline hover:text-stone-800" data-id="element-4524" data-mp="2jmnvon0i044q">Privacybeleid</a>
          <a href={SALES_PAGE_URL} className="underline hover:text-stone-800" data-id="element-4525" data-mp="2enuiywt1ch5m">Algemene voorwaarden</a>
        </div>
        <p className="mt-4" data-id="element-4526" data-mp="2td8ry3sp8wkh">Dit artikel wordt je aangeboden door Stressless Dogs.</p>
      </footer>

      {showStickyCta && <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#e8c7b7] bg-white/95 p-3 shadow-[0_-5px_18px_rgba(47,34,27,0.12)] backdrop-blur md:hidden" data-id="element-4527" data-mp="2oh1ii113h2xs">
          <div className="mx-auto flex max-w-lg items-center gap-3" data-id="element-4528" data-mp="2xgojilpww6qb">
            <p className="whitespace-nowrap text-sm font-bold text-[#6c3827]" data-id="element-4529" data-mp="8mycwqzyufxb">48% korting</p>
            <a href={SALES_PAGE_URL} className="flex flex-1 items-center justify-center rounded-xl bg-[#c9653d] px-4 py-3 font-bold text-white shadow-sm" data-id="element-4530" data-mp="dl0644r3vvmi">
              Bekijk de cursus
            </a>
          </div>
        </div>}
    </div>;
}
export function VijfRedenenCommunicerenAdv6KortLcPage() {
  return <VijfRedenenCommunicerenAdv6KortLcContent data-id="element-4531" data-mp="3m35z4h8fep98" />;
}